var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneNumber(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1111_5060",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1111_5060",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAABmJLR0QA/wD/AP+gvaeTAAAD/UlEQVR4nO3cSYgdRRzH8U8Wg1swGhRHohBNQJRgRAhBo+DFBT0IQoiBJHoQEQQPHsSDnrwEUdyOgktEcSEHJS54iKIYBRdcEFFHHSVEzCjilkSTeR4qj0xkJnmvurt6qqe+8D92vd//94rq6n8tFAqFQqFQKBQKhcIs4hhswGvYjV/wNJa0KaprXIFR9KaI73Fae9K6wVw8gAlTm9yPZ9sS2AUW4EVHNrgfE7i0HZl5Mw/PGczkfnyG+W2IzZnNhjO5H7e2ITZXrnH0MXm6GMcp6SXnx/H4VpzJ/Xg0ueoMuUs1k3vYjxWphefEAuxU3egetifWnhVXqsfkfqxNKz8fHlSv0WPCmN9p5kY8c1HNGs7CnTW32Ql2qbdH97AHS1MmkQN71W90T/iML0zib80Y3RNetIWDjGvO6M91tA4S8zIcrV3FIc7HjQ223xoxRn9Vu4rDWddw+60QY/R7tas4nE4Wm2KMfqN2FYfzQcPtZ0XVyt108S/OS5hHMmJ6NDxVq4pDPIIvGmo7S84Uypx19uafcFLKJHJhm3qN3pBWfj5crD6T38GctPLz4nXVTd6PlamF58Zq1Y1+LLnqTHlGNaMvSS85T0bwm3ijZ0UdOnYePZlduLvC82UlfAjm4X1xPfrdg88XBuQc/C7O7M0t6M2am8WP1Te1oDdrnhdn9B6sakFvtizGd+LM/lGYxRQG5AL8Jc7sT3Fyesn5sl78eL0DJ6SXnC/3izf7ZR1dEW+C+cIxuFizn1SqegOzEB+JN/thxeyBGRE/E+lhi3BQtDAAy/CzamN257f31sUa1fbuvY1FyVVnytXYJ97sT3BG5G+vwOPCHr/tQsmg0zOb6/CPeLN3Gu5zfREeEvaN/L+tL4U/v7Ncb+rEB4292HSU35iDjcJWhkHeAWfXldxMYxMOiDe7J/TUqerZFwqr68O0te9geyfWnehM4BbVzd4hDEfLcTmeUG2Dz5iOnhZbr9ow0lS8KRTIOsVa1V6QTcUBYa/hqc2lnp5rhQWAts2dKn7F7Tq0vnmVZg8kVY2PcVlj2SdmjXDpVdumThcTwrVFnbgj6lzVClEpYkxHbj8bwYfaN/RIsaWx7BOzULXFg6Zjd3Opp2e+astiTcZ4g3m3xjr8qX1zJ8e2RjNukZVm1kvyhmbTbZfF2Kp9k7/W8Xp2n434QzsmTwh3sc4algvHplMbfV+K5GYa83CbaicPhokX1LOJP1tOFyptsTdMDhJbcWyqhGY6q/CK+sfke83ynjwdq/GS6sepR5VriAZiCe7BN4Yz+AfcgeOqCpiNe9qWCdOy1cKMZalwDSjhq3NU2Cv4Kt4SltgKhUKhUCgUCoVCoVAoFAqT+A8/NGIgVlAVGAAAAABJRU5ErkJggg=="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneNumber);
export default __webpack_public_path__ + "static/media/phoneNumber.a2476dfb18d78d6f123c78d6bb115b05.svg";
export { ForwardRef as ReactComponent };